(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["el-editorial-home"] && !Shopify.designMode) return;
  try {
    
function initEditorial(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const header=root.querySelector('[data-header]');
  const menu=root.querySelector('[data-menu]');
  const toggle=root.querySelector('[data-menu-toggle]');
  const film=root.querySelector('.hero-film');
  const filmToggle=root.querySelector('[data-film-toggle]');
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const closeMenu=()=>{menu.classList.remove('is-open');menu.setAttribute('aria-hidden','true');menu.inert=true;toggle.setAttribute('aria-expanded','false');toggle.setAttribute('aria-label',root.dataset.openMenu);document.body.classList.remove('menu-open');header.classList.remove('menu-is-open');};
  toggle.addEventListener('click',()=>{if(toggle.getAttribute('aria-expanded')==='true'){closeMenu();return;}menu.inert=false;menu.classList.add('is-open');menu.setAttribute('aria-hidden','false');toggle.setAttribute('aria-expanded','true');toggle.setAttribute('aria-label',root.dataset.closeMenu);header.classList.add('menu-is-open');document.body.classList.add('menu-open');menu.querySelector('a')?.focus();});
  menu.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
  root.addEventListener('keydown',e=>{if(toggle.getAttribute('aria-expanded')!=='true')return;if(e.key==='Escape'){closeMenu();toggle.focus();}if(e.key==='Tab'){const links=[toggle,...menu.querySelectorAll('a')];const i=links.indexOf(document.activeElement);if(e.shiftKey&&i===0){e.preventDefault();links.at(-1).focus();}else if(!e.shiftKey&&i===links.length-1){e.preventDefault();toggle.focus();}}});
  const scroll=()=>header.classList.toggle('is-solid',window.scrollY>root.querySelector('.hero').offsetHeight*.82);
  window.addEventListener('scroll',scroll,{passive:true});scroll();
  window.addEventListener('resize',()=>{if(window.innerWidth>800)closeMenu();},{passive:true});
  const syncFilm=()=>{filmToggle.textContent=film.paused?root.dataset.play:root.dataset.pause;filmToggle.setAttribute('aria-label',film.paused?root.dataset.playLabel:root.dataset.pauseLabel);};
  film.addEventListener('play',syncFilm);film.addEventListener('pause',syncFilm);
  film.addEventListener('error',()=>{filmToggle.hidden=true;});
  const mobile=window.matchMedia('(max-width: 800px)');
  const chooseSource=()=>{const source=mobile.matches&&film.dataset.mobileSrc?film.dataset.mobileSrc:film.dataset.desktopSrc;if(source&&film.getAttribute('src')!==source){const wasPaused=film.dataset.userPaused==='true';film.src=source;film.load();if(!reduced.matches&&!wasPaused)film.play().catch(syncFilm);}};
  mobile.addEventListener('change',chooseSource);chooseSource();
  const motion=()=>{if(reduced.matches){film.pause();film.removeAttribute('autoplay');filmToggle.hidden=true;}else{filmToggle.hidden=false;}};
  reduced.addEventListener('change',motion);motion();syncFilm();
  filmToggle.addEventListener('click',()=>{if(film.paused){film.dataset.userPaused='false';film.play().catch(syncFilm);}else{film.dataset.userPaused='true';film.pause();}});
  if(!reduced.matches)film.play().catch(syncFilm);
  document.addEventListener('shopify:section:unload',e=>{if(e.target.contains(root)){window.removeEventListener('scroll',scroll);closeMenu();}});
}
document.querySelectorAll('[data-editorial]').forEach(initEditorial);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-editorial]').forEach(initEditorial));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
